import React, { useReducer, useEffect } from 'react';
import PrestadorContext from './PrestadorContext';
import PrestadorReducer from './PrestadorReducer';
// import Swal from 'sweetalert2';
import axios from 'axios';
import { 
    CONSULTAR_API_PRESTADORES,
    JSON_RESPUESTA_API,
    DATOS_METODO_PRESTADOR,
    RESPUESTA_API_PRESTADORES
} from '../../Types';

const LoginState = props => {

    //SE DEFINEN LOS STATE
    const initialState = {
        consulta_prestadores: false,
        json_resp: "",
        datos_metodo_prestador: [],
        respuesta_api_prestadores: ""
    }

    //crear dispatch y state
    const [state, dispatch ] = useReducer(PrestadorReducer, initialState);

    const Consulta_Prestadores_F = consulta_prestadores => {

        dispatch({
            type: CONSULTAR_API_PRESTADORES,
            payload: consulta_prestadores
        })
    }

    const Json_Resp_F = json_resp => {
        dispatch({
            type: JSON_RESPUESTA_API,
            payload: json_resp
        })
    }

    const Datos_Metodo_F = datos_metodo_prestador => {
        dispatch({
            type: DATOS_METODO_PRESTADOR,
            payload: datos_metodo_prestador
        })
    }

    const Respuesta_Prestadores_F = respuesta_api_prestadores =>{
        dispatch({
            type: RESPUESTA_API_PRESTADORES,
            payload: respuesta_api_prestadores
        })
    }

    const apikey = localStorage.getItem('apikey')
//consulta prestadores
useEffect(() => {

    const ConsultarPrestadores = async () => {
        

        if(state.datos_metodo_prestador.rutpres !== null && state.datos_metodo_prestador.rutpres !== undefined){

            try {
                const url = state.datos_metodo_prestador.formato_json === 'json' ? 
                `${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/${state.datos_metodo_prestador.rutpres}.json/` 
                : 
                `${process.env.REACT_APP_ENLACE_EXT}prestadores/rut/${state.datos_metodo_prestador.rutpres}.hl7/`

                const respuesta = await axios.get(url, {
                    params: {
                        apikey: apikey
                    }
                });
                
                if(respuesta.status === 200){
                    Respuesta_Prestadores_F(respuesta.status)
                    var textedJson2 = JSON.stringify(respuesta.data, undefined, 4);
                    Json_Resp_F(textedJson2)
                    Consulta_Prestadores_F(false)
                }else if(respuesta.status === 204){
                    Respuesta_Prestadores_F(respuesta.status)
                    Consulta_Prestadores_F(false)
                    Json_Resp_F("No se encontraron registros con ese rut.")   
                }
        
            } catch (error) {
                Respuesta_Prestadores_F(500)
                Consulta_Prestadores_F(false)
                Json_Resp_F("Error con la conexión al servidor, intente nuevamente.")  
            }


        }else if(state.datos_metodo_prestador.nroregistro !== null && state.datos_metodo_prestador.nroregistro !== undefined){

            try {
                const url = 
                state.datos_metodo_prestador.formato_json === 'json' ? 
                `${process.env.REACT_APP_ENLACE_EXT}prestadores/registro/${state.datos_metodo_prestador.nroregistro}.json/`
                : 
                `${process.env.REACT_APP_ENLACE_EXT}prestadores/registro/${state.datos_metodo_prestador.nroregistro}.hl7/`
                
                const respuesta = await axios.get(url, {
                    params: {
                        apikey: apikey
                    }
                });

                if(respuesta.status === 200){
                    Respuesta_Prestadores_F(respuesta.status)
                    var textedJson1 = JSON.stringify(respuesta.data, undefined, 4);
                    Json_Resp_F(textedJson1)
                    Consulta_Prestadores_F(false)
                }else if(respuesta.status === 204){
                    Respuesta_Prestadores_F(204)
                    Consulta_Prestadores_F(false)
                    Json_Resp_F("No se encontraron registros con ese rut.")   
                }
        
            } catch (error) {
                Respuesta_Prestadores_F(500)
                Consulta_Prestadores_F(false)
                Json_Resp_F("Error con la conexión al servidor, intente nuevamente.")  
            }
        }
    }

    if(state.consulta_prestadores){
        ConsultarPrestadores();  
    }

    //eslint-disable-next-line
}, [ state.consulta_prestadores]);

    return(

        <PrestadorContext.Provider
            value={{
                consulta_prestadores: state.consulta_prestadores,
                json_resp: state.json_resp,
                datos_metodo_prestador: state.datos_metodo_prestador,
                respuesta_api_prestadores: state.respuesta_api_prestadores,
                Consulta_Prestadores_F,
                Json_Resp_F,
                Datos_Metodo_F,
                Respuesta_Prestadores_F


            }}
        >

            {props.children}
        </PrestadorContext.Provider>

    )
}

export default LoginState;